module.exports = __webpack_public_path__ + "static/media/ex-reenvio-arquivos.1691409f.png";